import {
    GET_CONTACTS_REQUEST,
    GET_CONTACTS_SUCCESS,
    GET_CONTACTS_FAILURE,
    GET_CONTACT_REQUEST,
    GET_CONTACT_SUCCESS,
    GET_CONTACT_FAILURE,
    GET_TYPING_CONTACTS_REQUEST,
    SET_CONTACTS,
    SET_CONTACT,
    SUBMIT_CONTACT_SUCCESS,
    SUBMIT_CONTACT_REQUEST,
    SUBMIT_CONTACT_FAILURE
} from '../actions/contacts';
import { buildContacts } from '../helpers/contacts';
const initialState = {
    fetching: false,
    submitFetching: false,
    submitSuccess: false,
    contacts: [],
    contact: {},
    total: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CONTACTS_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false
            };
        }
        case GET_TYPING_CONTACTS_REQUEST: {
            return {
                ...state,
                fetching: true,
                contacts: [],
                total: 0
            };
        }
        case GET_CONTACTS_SUCCESS: {
            return {
                ...state,
                fetching: false,
                contacts: state.contacts.concat(buildContacts(action.payload.contacts)),
                total: (!action.payload.total || action.payload.total === 0) ? state.total : action.payload.total
            };
        }
        case GET_CONTACTS_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_CONTACTS: {
            return {
                ...state,
                contacts: action.payload.contacts,
                total: action.payload.total
            };
        }
        case SET_CONTACT: {
            return {
                ...state,
                contact: action.payload.contact
            };
        }

        case SUBMIT_CONTACT_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_CONTACT_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                contact: action.payload.contact,
                submitSuccess: true
            };
        }
        case SUBMIT_CONTACT_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case GET_CONTACT_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_CONTACT_SUCCESS: {
            return {
                ...state,
                contact: action.payload.contact,
                fetching: false
            };
        }
        case GET_CONTACT_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        default:
            return state;
    }
};
